{
  "header": "รายละเอียดอุปกรณ์",
  "subtitle": "อุปกรณ์ที่ต่อพ่วงกับรถบรรทุกของคุณ (รถพ่วง ตู้คอนเทนเนอร์ ฯลฯ)",
  "assetType": "ประเภทอุปกรณ์",
  "assetTypePlaceholder": "เลือกประเภทอุปกรณ์",
  "assetId": "รหัสอุปกรณ์ (เช่น หมายเลขรถพ่วง)",
  "assetIdPlaceholder": "เช่น หมายเลขรถพ่วง รหัสตู้คอนเทนเนอร์ ฯลฯ",
  "remove": "ลบ",
  "addAnother": "เพิ่มอุปกรณ์อื่น",
  "trailerType": "ประเภทรถพ่วง",
  "trailerId": "รหัสรถพ่วง"
}
